import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import Constants from '../../common/Constants';
import Cookies from '../Cookies/Cookies';
// eslint-disable-next-line import/no-cycle
import { getFeatureflag } from '../Utils/Utils';
import LocalStorage from '../LocalStorage/LocalStorage';

export const setValue = (key, value, setToCookie, isSecure) => {
    if (isNil(value) || isNil(key)) {
        return;
    }
    const storage = LocalStorage.setData(key, value);
    /* istanbul ignore next */
    if (!storage || setToCookie) {
        Cookies.save(key, value, undefined, undefined, isSecure);
    }
};

class TokenProvider {
    static get(key, readFromCookie = false) {
        /*
            1. DP_USER_STATE SHOULD BE READ FROM COOKIE FOR ALL CLIENTS
            2. DP_USER_STATE FALLBACK IS LOCAL STORAGE.
        */
        if (key === Constants.DP_USER_STATE) {
            readFromCookie = true;
        }
        /* istanbul ignore next */
        if (readFromCookie) {
            return Cookies.load(key, true);
        }
        const localStorageValue = LocalStorage.getData(key);

        if (isEmpty(localStorageValue)) {
            return Cookies.load(key);
        }
        return localStorageValue;
    }

    /**
     * Returns access token, refresh token, account id, DP_USER_STATE
     */
    static getTokens() {
        const {
            ACCESS_TOKEN,
            REFRESH_TOKEN,
            DP_USER_STATE,
            ACCOUNT_ID,
            DP_FULL_ACCESS_EXPIRY,
        } = Constants;
        const tokens = {};
        tokens[ACCESS_TOKEN] = TokenProvider.get(ACCESS_TOKEN);
        tokens[REFRESH_TOKEN] = TokenProvider.get(REFRESH_TOKEN);
        tokens[DP_USER_STATE] = TokenProvider.get(DP_USER_STATE);
        tokens[ACCOUNT_ID] = TokenProvider.get(ACCOUNT_ID);
        tokens[DP_FULL_ACCESS_EXPIRY] = TokenProvider.get(DP_FULL_ACCESS_EXPIRY);
        return tokens;
    }

    // TODO: remove following function once setValue method called from all places.
    static set(key, value) {
        setValue(key, value);
    }

    static logout(timeOutFlag) {
        if (!timeOutFlag) {
            /* Store Info */
            Cookies.remove(Constants.USER_STORE);
            Cookies.remove(Constants.USER_STORE_INFO);
            LocalStorage.removeData(Constants.DP_USER_DEFAULT_STORE);

            LocalStorage.removeData(Constants.DP_USER_DEFAULT_ADDRESS_ZIP);
            Cookies.remove(Constants.DP_USER_DEFAULT_ADDRESS_ZIP);

            LocalStorage.removeData(Constants.DEFAULT_STORE, true);
            LocalStorage.removeData(Constants.USER_STORE, true);

            /* Onboarding */
            LocalStorage.removeData(Constants.DP_BARCODE_ONBOARDING_COMPLETED);

            /* Saved Items */
            LocalStorage.removeData(Constants.DP_SAVED_ITEMS_PAYLOAD);
            LocalStorage.removeData(Constants.DP_SAVED_ITEMS_COUNT);
            LocalStorage.removeData(Constants.DP_SAVED_ITEMS);
            LocalStorage.removeData(Constants.DP_CHECKOUT_SAVED_ITEMS);
            LocalStorage.removeData(Constants.DP_CHECKOUT_SAVED_ITEMS_PAYLOAD);
            Cookies.remove(Constants.DP_SFL_ID);
            LocalStorage.removeData(Constants.DP_SFL_ID);

            /* ATG Cookies Related To Session and Cart */
            Cookies.remove('userStoreInfo');
            Cookies.remove('StoreInfo');
            Cookies.remove('DPInstance');
            Cookies.remove('userStoreInfo');
            Cookies.remove('SLT');
        }
        /* User Lists */
        LocalStorage.removeData(Constants.DP_USER_LIST);
        /* Cart Details */
        Cookies.remove(Constants.ITEM_COUNT);

        /* PLCC Banner */
        LocalStorage.removeData(Constants.DP_HAS_JCP_CARD);
        LocalStorage.removeData(Constants.DP_JCP_CARD);

        /* User Name In Header */
        LocalStorage.removeData(Constants.DP_VISITOR_ID);
        LocalStorage.removeData(Constants.DP_FIRST_NAME);
        LocalStorage.removeData(Constants.DP_USER_NAME);
        Cookies.remove(Constants.DP_FIRST_NAME);
        Cookies.remove(Constants.DP_USER_NAME);

        /* User Name In Header */
        LocalStorage.removeData(Constants.ACCOUNT_ID);
        Cookies.remove(Constants.ACCOUNT_ID, 'www.jcpenney.com');
        Cookies.remove(Constants.ACCOUNT_ID);

        /* Rewards */
        LocalStorage.removeData(Constants.DP_REWARDS_CERTS);
        LocalStorage.removeData(Constants.DP_REWARDS_STATUS);
        LocalStorage.removeData('DP_REWARDS_POINTS_AWAY');
        LocalStorage.removeData('DP_REWARDS_CERTS_COUNT');

        /* Access Token, Refresh Token */
        LocalStorage.removeData(Constants.ACCESS_TOKEN);
        Cookies.remove(Constants.ACCESS_TOKEN);
        Cookies.remove(Constants.ACCESS_TOKEN, 'www.jcpenney.com');
        LocalStorage.removeData(Constants.REFRESH_TOKEN);
        Cookies.remove(Constants.REFRESH_TOKEN);
        Cookies.remove(Constants.REFRESH_TOKEN, 'www.jcpenney.com');

        /* ANALYTICS CUSTOMER STATE */
        if (Cookies.load(Constants.DP_USER_STATE) === '2') {
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_RECOG_GUEST);
        } else {
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_GUEST);
        }

        /* REMEMBER FOR EMAIL */
        if (LocalStorage.getData('DP_USER_REMEMBER') !== '1') {
            LocalStorage.removeData('DP_USER_EMAIL');
            LocalStorage.removeData('DP_USER_EMAIL_HASHED');
        }

        LocalStorage.removeData(Constants.DP_KEEP_ME_LOGGED);

        /* PHONE NO */
        LocalStorage.removeData(Constants.DP_PHONE_NUMBER);
        LocalStorage.removeData(Constants.DP_PHONE_VERIFIED_STATUS);
        LocalStorage.removeData(Constants.DP_PHONE_NUMBER_TYPE);

        /* CrossSellInfo */
        LocalStorage.removeData(Constants.CROSS_SELL);

        /* DP USER STATE */
        setValue(Constants.DP_USER_STATE, '0');
        setValue(Constants.DP_USER_STATE, '0', true);

        LocalStorage.removeData(Constants.DP_USER_TOKEN);
        LocalStorage.removeData(Constants.DP_FULL_ACCESS_EXPIRY);

        /* Clear curbside data */
        LocalStorage.removeData(Constants.DP_CURBSIDE_CHECKIN_INFO);
        LocalStorage.removeData(Constants.DP_CURBSIDE_PRODUCT_INFO);

        /* Clear lost cart logging */
        LocalStorage.removeData(Constants.DP_EMPTY_CART_LOGGING, true);

        /* APLLIED COUPON cookie */
        Cookies.remove('COUPON_STATE');

        /* Clear rewards pilot cookie */
        Cookies.remove('eligibleForRewardsPilot');

        /* ATG Cookies */
        Cookies.remove('DP_USER_INFO');
        Cookies.remove('DP_REFRESH_TOKEN');
        Cookies.remove('APITOKEN');
        Cookies.remove('DPSecureCookie');
        Cookies.remove('DYN_USER_CONFIRM');
        Cookies.remove('DYN_USER_ID');
        Cookies.remove('DP_AUTH_TOKEN');
        Cookies.remove('DP_USER_AUTH_STATUS');
        Cookies.remove('rewardsPointsCookie');
        Cookies.remove('omni_profileType');
        Cookies.remove('omni_profileAttr');
        Cookies.remove('omni_profileOptin');
        Cookies.remove('sk_jcpprofile_id');
        Cookies.remove('DP_USER_AUTH_STATUS');
        Cookies.remove('DP_USER_AUTH_STATUS');
        Cookies.remove('DPOrder');
        Cookies.remove('ItemCount');
        Cookies.remove('ItemTotal');
        Cookies.remove('InternationalItemTotal');
        Cookies.remove('DP_ORDER_INFO');

        // Email optin
        LocalStorage.removeData('isEmailOpted');
    }

    static storeTokens(response, source) {
        let accessToken = '';
        let refreshToken = '';
        let accountId = '';
        let guestUser = false;
        let userName = response.headers.get('DP_FIRST_NAME');
        const customerState = LocalStorage.getData(Constants.ANALY_CUST_STATE);
        const sflId = response.headers.get('DP_SFL_ID');
        const hasJCPCard = response.headers.get('DP_USER_HAS_JCP_CARD');
        const defaultStore = response.headers.get(Constants.DP_USER_DEFAULT_STORE);
        const defaultZip = response.headers.get(Constants.DP_USER_DEFAULT_ADDRESS_ZIP);
        // Added this condition if response header is not returning first name then ui can retrive from response.data so that desktop esi header wont break
        if (!userName) {
            userName = response.data.firstName;
        }
        const userRewardStatus = response.headers.get('DP_REWARDS_STATUS');
        let userState = response.headers.get('DP_USER_STATE')
            ? response.headers.get('DP_USER_STATE')
            : response.userState;
        const keepMeLoggedInHeader = response.headers.get(Constants.X_DEVICE_REGISTERED);
        if (keepMeLoggedInHeader === 'true') {
            // opted keepme logged and clearkey respond registered
            TokenProvider.set(Constants.DP_KEEP_ME_LOGGED, '1');
        } else if (keepMeLoggedInHeader === 'false') {
            // opted keepme logged and clearkey respond not registered
            TokenProvider.set(Constants.DP_KEEP_ME_LOGGED, '0');
        } else {
            // recognized --> user not opted when steup
            LocalStorage.removeData(Constants.DP_KEEP_ME_LOGGED);
        }

        /* istanbul ignore next */
        if (userState === '1' && customerState === Constants.ANALY_LOGIN_RECOG) {
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_RECOG_LOGIN);
        } else if (userState === '1') {
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_LOGIN);
        } else if (userState === '2') {
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_LOGIN_RECOG);
        } else if (userState === '0' && customerState === Constants.ANALY_LOGIN_RECOG) {
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_RECOG_GUEST);
        } else if (userState === '0' && customerState !== Constants.ANALY_RECOG_GUEST) {
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_GUEST);
        }

        const phoneNumber = response.headers.get(Constants.DP_PHONE_NUMBER);
        const phoneVerificationStatus = response.headers.get(Constants.DP_PHONE_VERIFIED_STATUS);
        const phoneNumberType = response.headers.get(Constants.DP_PHONE_NUMBER_TYPE);
        const vistorId = response.headers.get('DP_VISITOR_ID');
        const savedItemsCount = response.headers.get('DP_USER_FAVCOUNT');
        const userToken = response.headers.get('DP_USER_TOKEN');
        const userLists = response.headers.get(Constants.DP_USER_LIST);
        /* Read from Token API look for rewards pilot indicator and set it to cookies */
        this.storeRewardsPilotCookie(response.data);
        if (source === 'body') {
            accessToken = response.data.access_token;
            refreshToken = response.data.refresh_token;
            accountId = response.data.account_id;
            guestUser = response.isGuestUser;
            const tokenApiStatus = response.data.isTemp ? 'true' : 'false';
            setValue(Constants.TOKEN_API_STATUS, tokenApiStatus);
            if (response.data.isTemp) {
                userState = '0';
            }
        } else {
            accessToken = response.headers.get(Constants.ACCESS_TOKEN);
            refreshToken = response.headers.get(Constants.REFRESH_TOKEN);
            accountId = response.data.account_id;
            // Look at the location header in case if the account id is not in body as fallback case.
            if (isEmpty(accountId)) {
                const location = response.headers.get('Location');
                accountId = location ? location.split('/').pop() : '';
            }
        }
        setValue(Constants.DP_USER_LIST, userLists);
        setValue(Constants.ACCESS_TOKEN, accessToken, true);
        setValue(Constants.REFRESH_TOKEN, refreshToken);
        setValue(Constants.DP_USER_DEFAULT_STORE, defaultStore);
        setValue(Constants.DP_USER_DEFAULT_ADDRESS_ZIP, defaultZip, true);
        setValue(Constants.ACCOUNT_ID, accountId, true);
        setValue(Constants.DP_USER_STATE, userState, true);
        setValue(Constants.DP_HAS_JCP_CARD, hasJCPCard);
        setValue(Constants.DP_FIRST_NAME, userName);
        setValue(Constants.DP_USER_NAME, userName);
        setValue(Constants.DP_REWARDS_STATUS, userRewardStatus);
        setValue(Constants.DP_VISITOR_ID, vistorId);
        setValue(Constants.DP_SFL_ID, sflId);
        setValue(Constants.DP_SAVED_ITEMS_COUNT, savedItemsCount);
        setValue(Constants.GUEST_USER, guestUser);
        setValue(Constants.DP_USER_TOKEN, userToken);
        setValue(Constants.DP_PHONE_NUMBER, phoneNumber);
        setValue(Constants.DP_PHONE_VERIFIED_STATUS, phoneVerificationStatus);
        setValue(Constants.DP_PHONE_NUMBER_TYPE, phoneNumberType);
        Cookies.save(Constants.DP_SFL_ID, sflId);
    }

    static storeTokenFromServer(data) {
        const userState = data[Constants.DP_USER_STATE];
        const customerState = LocalStorage.getData(Constants.ANALY_CUST_STATE);

        /* istanbul ignore next */
        if (userState === '1' && customerState === Constants.ANALY_LOGIN_RECOG) {
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_RECOG_LOGIN);
        } else if (userState === '1') {
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_LOGIN);
        } else if (userState === '2') {
            LocalStorage.removeData(Constants.DP_KEEP_ME_LOGGED);
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_LOGIN_RECOG);
        } else if (userState === '0' && customerState === Constants.ANALY_LOGIN_RECOG) {
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_RECOG_GUEST);
        } else if (userState === '0' && customerState !== Constants.ANALY_RECOG_GUEST) {
            setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_GUEST);
        }
        setValue(Constants.ACCESS_TOKEN, data[Constants.ACCESS_TOKEN], true);
        setValue(Constants.REFRESH_TOKEN, data[Constants.REFRESH_TOKEN]);
        setValue(Constants.ACCOUNT_ID, data[Constants.ACCOUNT_ID], true);
        if (data[Constants.DP_USER_STATE]) {
            setValue(Constants.DP_USER_STATE, data[Constants.DP_USER_STATE], true);
        }
        this.storeRewardsPilotCookie(data);
        if (!__SERVER__) {
            const cookieList = data.cookieList || [];
            forEach(cookieList, (cookieItem) => {
                const cookieItems = cookieItem.cookie.split('~');
                forEach(cookieItems, (cookie) => {
                    document.cookie = cookie;
                });
            });
        }
    }

    /**
     * Set access token and account id to cookie if it is not set
     */
    static setAccessToken() {
        if (__SERVER__) {
            return;
        }
        const accessTokenLS = LocalStorage.getData(Constants.ACCESS_TOKEN);
        const accountIdLS = LocalStorage.getData(Constants.ACCOUNT_ID);
        /* istanbul ignore next */
        !isEmpty(accessTokenLS) && Cookies.save(Constants.ACCESS_TOKEN, accessTokenLS);
        /* istanbul ignore next */
        !isEmpty(accountIdLS) && Cookies.save(Constants.ACCOUNT_ID, accountIdLS);
    }

    static storeRewardsPilotCookie(tokenResponse) {
        const enableRewardsPilotProgram = getFeatureflag('enableRewardsPilotProgram');
        const { cookieList, shippingPromo } = tokenResponse;
        /* istanbul ignore next */
        if (enableRewardsPilotProgram && !isEmpty(tokenResponse) && isEmpty(cookieList)) {
            if (!isEmpty(shippingPromo)) {
                Cookies.save('eligibleForRewardsPilot', JSON.stringify(shippingPromo));
            } else {
                Cookies.remove('eligibleForRewardsPilot');
            }
        }
    }

    static setTokensFromNativeApp(data = {}) {
        if (!isEmpty(data)) {
            const accessToken = data.access_token || get(data, 'response.data.access_token', '');
            const refreshToken = data.refresh_token || get(data, 'response.data.refresh_token', '');
            const accountId = data.account_id || get(data, 'response.data.account_id', '');
            const expires_in = data.expires_in || get(data, 'response.data.expires_in', null);
            const email = get(data, 'email', '');
            const firstName = data.firstName || get(data, 'response.data.firstName', '');

            setValue(Constants.ACCESS_TOKEN, accessToken, true);
            setValue(Constants.REFRESH_TOKEN, refreshToken);
            setValue(Constants.ACCOUNT_ID, accountId, true);
            data.email && setValue('DP_USER_EMAIL', email, true);
            data.DP_USER_STATE && setValue(Constants.DP_USER_STATE, data.DP_USER_STATE, true);
            setValue(Constants.DP_REWARDS_STATUS, data.DP_REWARDS_STATUS);
            setValue(Constants.DP_VISITOR_ID, data.DP_VISITOR_ID);
            setValue(Constants.DP_USER_PROFILE_TYPE, data.DP_USER_PROFILE_TYPE, true);
            setValue(Constants.DP_REWARDS_TIER, data.DP_REWARDS_TIER);
            setValue(Constants.DP_FIRST_NAME, firstName, '');
            setValue(Constants.DP_USER_NAME, firstName, '');
            if (data.DP_USER_STATE === 1 || data.DP_USER_STATE === '1') {
                setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_LOGIN);
            } else if (data.DP_USER_STATE === 0 || data.DP_USER_STATE === '0') {
                setValue(Constants.DP_USER_STATE, data.DP_USER_STATE, true);
                setValue(Constants.ANALY_CUST_STATE, Constants.ANALY_GUEST);
            }
            expires_in && setValue(Constants.DP_FULL_ACCESS_EXPIRY, expires_in.toString(), true);
            // remove this after testing
            console.log('Tokens are updated', JSON.stringify(data));
        }
    }
}

export default TokenProvider;
